import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=90c9fb2c"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"
import style0 from "./Proposal.vue?vue&type=style&index=0&id=90c9fb2c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90c9fb2c')) {
      api.createRecord('90c9fb2c', component.options)
    } else {
      api.reload('90c9fb2c', component.options)
    }
    module.hot.accept("./Proposal.vue?vue&type=template&id=90c9fb2c", function () {
      api.rerender('90c9fb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IncubatorApply/Proposal.vue"
export default component.exports